import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { DialogType, NotificationArgs, SabisNgxNotificationService, SabisToaster2Service } from '../../../../dist/sabis-components2';
import { SabisTranslateService } from 'sabis-components2';


@Injectable({
  providedIn: 'root'
})
export class AppNotificationsService {
  onShowNotificationNotice: Subject<NotificationArgs> = new Subject();

  constructor(
    private _toaster: SabisToaster2Service,
    private _notifications: SabisNgxNotificationService) { }

  public notifySaveSucceeded(): void {
    this._toaster.showSuccess('Saved successfully');
  }

  public notifyEmailSent(): void {
    this._toaster.showSuccess('Email Sent');
  }

  public notifySaveFailed(): void {
    this._toaster.showError('Save failed');
  }

  public notifyUnarchiveFailed(): void {
    this._toaster.showError('Unarchive failed');
  }

  public notifyDeleteFailed(): void {
    this._toaster.showError('Delete failed');
  }

  public notifyDeleteSucceeded(): void {
    this._toaster.showError('Deleted successfully');
  }

  public showInvalidEntriesMessage(): void {
    this._toaster.showError('One or more invalid entries!');
  }

  public completeRequiredFieldMessage(): void {
    this._toaster.showError('Please complete the required fields.');
  }

  public confirmDeleteMessage(): Observable<boolean> {
    return this._notifications.confirm('Are you sure you want to delete this record?', 'Confirmation');
  }

  public confirmActivateDeactivateMessage(action: string): Observable<boolean> {
    return this._notifications.confirm(`Are you sure you want to ${action} this record?`, 'Confirmation');
  }

  public notifyRecordActivatedDeactivated(isDeactivated: boolean): void {
    this._toaster.showSuccess(isDeactivated ? `Activated successfully` : `Deactivated successfully`);
  }

  public confirmApproveMessage(field: string): Observable<boolean> {
    return this._notifications.confirm(`Are you sure you want to approve this ${field}?`, 'Confirmation');
  }

  public sameProfileSelectedMessage(profile: string): void {
    this._toaster.showError(`The same ${profile} can be selected only once.`);
  }

  public mandatorySelectionMessage(profile: string): void {
    this._toaster.showError(`Please select at least one ${profile}.`);
  }

  public confirmResendEmailMessage(): Observable<boolean> {
    return this._notifications.confirm('Are you sure you want to resend this email?', 'Confirmation');
  }

  public confirmCancelEmailMessage(): Observable<boolean> {
    return this._notifications.confirm('Are you sure you want to cancel this email?', 'Confirmation');
  }

  public confirmUnarchiveRequisitionMessage(requisitionTitle: string): Observable<boolean> {
    return this._notifications.confirm(`Are you sure you want to unarchive ${requisitionTitle}?`, 'Confirmation');
  }

  public confirmCompleteStep(): Observable<boolean> {
    return this._notifications.confirm('Are you sure you want to complete this step?', 'Confirmation');
  }

  public notifyRecordClosedUnarchived(isClosed: boolean): void {
    this._toaster.showSuccess(isClosed ? 'Unarchived successfully' : 'Closed successfully');
  }

  public notifyAccessDenied(): void {
    this._toaster.showError(`You do not have the needed access right. Please contact your system administrator.`);
  }

  public notifyCopiedToClipboard(): void {
    this._toaster.showSuccess('Copied to clipboard');
  }

  public unexpectedErrorOccurred(): void {
    this._toaster.showError('Unexpected error occurred');
  }

  public confirmCancelRequest(): Observable<boolean> {
    return this._notifications.confirm(`Are you sure you want to cancel this request?`, 'Confirmation');
  }

  public notifySearchFailed(): void {
    this._toaster.showError('Search failed');
  }

}
